import React, { useState } from 'react';
import axios from "axios";
import '../App.css';
import Top_Banner_All from '../assests/Top_Banner_All.jpg';

const Contact = () => {
  const [formData, setFormData] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
 
  const handleSubmit = async (e) => {
    e.preventDefault();
    const url = process.env.REACT_APP_BACKEND_URL;   
    try {
      const response = await axios.post(`${url}api/contact/form`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      .then(response => {
        console.log("Form submitted successfully:", response.data);
        setFormData({
          fullName: "",
          email: "",
          phone: "",
          comment: ""
        });
      })
      .catch(error => {
        console.error("Axios error:", error.response ? error.response.data : error.message);
      });
  
      console.log(response.data);

    } catch (error) {
      if (error.response) {
        // The request was made and the server responded with a status code
        console.error("Response error data:", error.response.data);
        console.error("Response status:", error.response.status);
      } else if (error.request) {
        // The request was made but no response was received
        console.error("No response received:", error.request);
      } else {
        // Something happened in setting up the request that triggered an Error
        console.error("Axios error:", error.message);
      }
    }
  };  

  return (
    <>
      <section className="pricing-section">
        {/* First Child */}
        <div className="header-image-container">
          <header className={`pricing-header`}>
            <img src={Top_Banner_All} alt="Pricing Background" className="pricing-img" />
            <h1 className="pricing-title">Contact Us</h1>
          </header>
        </div>
      </section>
      <section className="contact-us">
        <div className="contact-info">
          <h2>We are here to help you! To Shape Your Body.</h2>
          <p>
            At our Vortex Gym, we are dedicated to helping you achieve the body of your dreams. Our expert trainers and nutritionists will work with you to create a personalized fitness and nutrition plan that helps you reach your specific goals.
          </p>
          <div className="info-details">
            <div>
              <h3>Chennai, Tamil Nadu, India</h3>
              <p>4/20, Gopala Menon St, near Ayyappa Ground, Choolai, Chennai</p>
            </div>
            <div>
              <h3>Opening Hours</h3>
              <p>Monday to Saturday : 5:00 am - 10:00 pm</p>
              <p>On Sunday : 6:00 am - 2:00 pm</p>
            </div>
            <div>
              <h3>Contact Information</h3>
              <p>+91 9876543210</p>
              <p>gym@gmail.com</p>
            </div>
            <div className="social-media">
              <h3>Follow Us On</h3>
              <div className="social-icons">
              <a href="https://www.linkedin.com/in/vrushabh-somani-2b0603206/" target="_blank"><img width="30" height="30" src="https://img.icons8.com/fluency/30/linkedin.png" alt="linkedin"/></a>
            <a href="https://www.instagram.com/vrushabhsomani/" target="_blank"><img width="30" height="30" src="https://img.icons8.com/fluency/30/instagram-new.png" alt="instagram-new"/></a>
            <a href="https://x.com/VrushabhSomani" target="_blank"><img width="30" height="30" src="https://img.icons8.com/windows/30/twitterx.png" alt="twitterx"/></a>
            <a href="https://www.facebook.com/VrushabhSomani/" target="_blank"><img width="30" height="30" src="https://img.icons8.com/color/96/facebook-new.png" alt="facebook-new"/></a>
              </div>
            </div>
          </div>
        </div>
        <div className="contact-form">
          <h3>Leave Us Your Info</h3>
          <form onSubmit={handleSubmit}>
            <input
              type="text"
              name="fullName"
              placeholder="Full Name *"
              required
              value={formData.fullName}
              onChange={handleChange}
            />
            <input
              type="email"
              name="email"
              placeholder="Email Address *"
              required
              value={formData.email}
              onChange={handleChange}
            />
            <input
              type="tel"
              name="phone"
              placeholder="Phone No *"
              required
              value={formData.phone}
              onChange={handleChange}
            />
            <textarea
              name="comment"
              placeholder="Comment"
              required
              value={formData.comment}
              onChange={handleChange}
            ></textarea>
            <button type="submit">SUBMIT NOW</button>
          </form>
        </div>
      </section>
      <section>
        <h1>You Can Find Us Here</h1>
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3886.167377662103!2d80.25577637622112!3d13.088576479421793!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a52659401c932f1%3A0x773136f21f0e262f!2sJain%20colony!5e0!3m2!1sen!2sin!4v1723810893997!5m2!1sen!2sin"
          width="100%"
          height="500px"
          style={{ border: '0' }}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </section>
    </>
  )
}

export default Contact;